/*
 * Scroll-into-view autoplay for decorative, muted, looping clips.
 *
 * Opt a video in with data-autoplay. Give it preload="none" and a real poster;
 * this script switches preload to auto and calls play() only once the clip is
 * about to be seen, so nothing downloads for a visitor who never scrolls to it.
 *
 * Phones ignore the bare autoplay attribute for an offscreen video, and iOS Low
 * Power Mode / Android Data Saver refuse play() outright no matter what. When
 * that happens we mark the wrapper data-tappable so the visitor can start the
 * clip themselves — several of these wrappers set pointer-events:none, which
 * would otherwise leave them stranded on the poster frame with a dead button.
 *
 * data-autoplay-skip-hidden: don't load a clip that CSS has hidden at this
 * breakpoint. The RFB hero ships a desktop and a mobile cut side by side, and
 * without this a phone downloads both.
 */
(function () {
  'use strict';

  function isHidden(el) {
    return !el.offsetParent && getComputedStyle(el).position !== 'fixed';
  }

  function attempt(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function enableTap(video) {
    // Decorative background clips (hero) opt out — a tap target there is noise.
    if (video.hasAttribute('data-autoplay-no-tap')) return;
    var wrap = video.parentElement;
    if (!wrap || wrap.dataset.tappable) return;
    wrap.dataset.tappable = '1';
    // pointer-events is often set inline on these wrappers, so a class cannot
    // win the cascade. Clear it on the element.
    wrap.style.pointerEvents = 'auto';
    wrap.style.cursor = 'pointer';
    wrap.addEventListener('click', function () { attempt(video); });
  }

  function start(video) {
    if (video.dataset.started) return;
    video.dataset.started = '1';

    video.preload = 'auto';
    video.load();
    attempt(video);

    var tries = 0;
    var timer = setInterval(function () {
      if (!video.paused) { clearInterval(timer); return; }
      if (tries++ > 10) { clearInterval(timer); enableTap(video); return; }
      attempt(video);
    }, 500);
  }

  function init() {
    var videos = document.querySelectorAll('video[data-autoplay]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      if (video.hasAttribute('data-autoplay-skip-hidden') && isHidden(video)) return;

      // Properties, not just attributes — some iOS builds honour only these.
      video.muted = true;
      video.playsInline = true;
      video.controls = false;

      if (!('IntersectionObserver' in window)) { start(video); return; }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          start(video);
        });
      }, { threshold: 0.1, rootMargin: '200px 0px' });

      io.observe(video);
    });
  }

  /* Wait for window load: an MP4 that starts before the first paint competes
     with the hero poster for bandwidth, and on a phone the 1080p hero clip
     alone pushed lab LCP to 11s. The poster shows until the clip is ready. */
  function boot() { setTimeout(init, 0); }
  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }
})();
